export default __webpack_public_path__ + "static/char-39-anr-58e62556e2051ca1fffde85b8ac78689.gif";